<template>
  <div class="container">
    <div class="mainEvent">
      <div class="inner-wrap">
        <a href="#">
          <img
            class="icon"
            :src="'//static.flybit.com/upload/m_ieo_banner1.gif'"
            alt
          />
        </a>
      </div>
    </div>
    <div id="container">
      <div class="IEO-main">
        <div class="tab" flex>
          <div
            :class="{ active: nowMenu == 'all' }"
            class="menu"
            @click="changeMenu('all')"
          >
            <p>{{ $t("ieo.list.all") }}</p>
          </div>
          <div
            :class="{ active: nowMenu == 'ing' }"
            class="menu"
            @click="changeMenu('ing')"
          >
            <p>{{ $t("ieo.list.open") }}</p>
          </div>
          <div
            :class="{ active: nowMenu == 'soon' }"
            class="menu"
            @click="changeMenu('soon')"
          >
            <p>{{ $t("ieo.list.prepare") }}</p>
          </div>
          <div
            :class="{ active: nowMenu == 'end' }"
            class="menu"
            @click="changeMenu('end')"
          >
            <p>{{ $t("ieo.list.close") }}</p>
          </div>
        </div>
        <!-- <ieo-layout> -->
        <!-- 전체 -->
        <div class="IEO-list-wrap">
          <ul class="list krw loadEnd">
            <li
              class="IEO-list"
              v-for="IEO in selectedIEOList"
              :key="IEO.tkCode"
            >
              <!-- <a class="default" @click="gotoIEODetail(IEO)"> -->
              <router-link
                class="default"
                :to="`/token-swap/detail/${IEO.tkCode}`"
              >
                <section class="IEO-upper">
                  <div class="IEO-info">
                    <!-- info: nowMenu == 'end' -->
                    <!-- soldout: IEO.completeYn === "Y" -->
                    <div class="header">
                      <div class="image-wrap">
                        <img
                          :src="
                            `//static.flybit.com/static/img/ieo/ieo_pr_${IEO.ieCode}.png?v=${imageVersion}`
                          "
                          alt
                        />
                      </div>
                      <div class="contents-wrap">
                        <div class="title-wrap">
                          <!-- 뱃지 -->
                          <div flex>
                            <div
                              v-if="
                                moment(IEO.endDatetime) < moment() ||
                                  IEO.completeYn === 'Y' ||
                                  (IEO.ieCnt / IEO.totalCount) * 100 > 99
                              "
                              class="badge-wrap end"
                              flex
                            >
                              <i
                                class="el-icon-success"
                                style="color: #707a8a; margin-right: 5px;"
                              />
                              <div>
                                <p class="status-badge end">
                                  {{ "진행 종료" }}
                                </p>
                              </div>
                            </div>
                            <div v-else class="badge-wrap" flex>
                              <i
                                class="el-icon-success"
                                style="color: #eb3246; margin-right: 5px;"
                              />
                              <div v-if="moment(IEO.startDatetime) > moment()">
                                <p class="status-badge soon">
                                  D-{{
                                    getRemainDate(IEO) != 0
                                      ? getRemainDate(IEO)
                                      : "day"
                                  }}
                                </p>
                                <!-- <p class="status-badge soon">{{ "진행 예정" }}</p> -->
                              </div>
                              <div v-else>
                                <p class="status-badge ing">{{ "진행중" }}</p>
                              </div>
                            </div>
                            <!-- whitelist badge -->
                            <div
                              v-if="isWhiteList(IEO.tkName)"
                              class="badge-wrap whiteList ml10"
                              flex
                            >
                              <i
                                class="el-icon-success"
                                style="color: #009a72; margin-right: 5px;"
                              />
                              <p class="status-badge whiteList">
                                {{ "WhiteList" }}
                              </p>
                            </div>
                            <!-- // whitelist badge -->
                          </div>
                          <!-- // 뱃지 -->
                          <h2 class="title" v-if="$i18n.locale == 'ko'">
                            {{ getTitle(IEO.tkName) }}
                          </h2>
                          <h2 class="title" v-else-if="$i18n.locale == 'ch'">
                            {{ getTitle(IEO.tkNameCa) }}
                          </h2>
                          <h2 class="title" v-else>
                            {{ getTitle(IEO.tkNameEn) }}
                          </h2>
                        </div>
                        <div class="content-wrap">
                          <p class="sub" v-if="$i18n.locale == 'ko'">
                            {{ IEO.comments }}
                          </p>
                          <p class="sub" v-else-if="$i18n.locale == 'ch'">
                            {{ IEO.commentsCa }}
                          </p>
                          <p class="sub" v-else>{{ IEO.commentsEn }}</p>
                        </div>
                        <div class="date-wrap">
                          <p>
                            <span class="c-gray">시작</span>
                            {{ convertDateFormat(IEO.startDatetime) }}
                          </p>
                          <p>
                            <span class="c-gray">종료</span>
                            {{ convertDateFormat(IEO.endDatetime) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <!-- </ieo-layout> -->
    </div>

    <!-- 기존코드 -->
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "IEOList",
  created() {
    this.$api.IEO.getSaleList().then((response) => {
      return (this.IEOList = _.get(response, ["data", "result"], []));
    });
  },

  data: () => ({
    IEOList: [],
    nowMenu: "all",
    active: false,
    imageVersion: new Date().getTime(),
    whiteListFlag: "(Whitelist)",
  }),
  computed: {
    selectedIEOList: {
      get: function() {
        switch (this.nowMenu) {
          case "all":
            return this.IEOList;
          case "ing":
            return this.IEOList.filter((ieo) => {
              return (
                moment().isBetween(
                  moment(ieo.startDatetime),
                  moment(ieo.endDatetime)
                ) &&
                ieo.completeYn === "N" &&
                (ieo.ieCnt / ieo.totalCount) * 100 < 99
              );
            });
          case "soon":
            return this.IEOList.filter((ieo) => {
              return moment(ieo.startDatetime) > moment();
            });
          case "end":
            return this.IEOList.filter((ieo) => {
              return (
                moment(ieo.endDatetime) < moment() ||
                ieo.completeYn === "Y" ||
                (ieo.ieCnt / ieo.totalCount) * 100 >= 99
              );
            });
        }
      },
      set: function(menuname) {
        this.nowMenu = menuname;
      },
    },
  },
  methods: {
    inPeriodNow(startDate, endDate) {
      return this.moment().isBetween(
        this.moment(startDate),
        this.moment(endDate)
      );
    },
    gotoIEODetail(IEO) {
      this.$router.push({ name: "IEODetail", params: { tkCode: IEO.tkCode } });
    },
    changeMenu(menuName) {
      this.selectedIEOList = menuName;
    },
    remainSaleDate(startDatetime) {
      //d-day
      return (
        -1 *
        moment()
          .startOf("day")
          .diff(moment(startDatetime), "days")
      );
    },
    convertDateFormat(date) {
      console.log("IEO.startDatetime", date);
      return this.moment(date).format("YYYY.MM.DD hh:mm");
    },
    //Dday 구하는 함수
    getRemainDate(IEO) {
      return (
        -1 *
        moment()
          .startOf("day")
          .diff(moment(IEO.startDatetime), "days")
      );
    },
    getTitle(title) {
      return title.indexOf(this.whiteListFlag) === -1
        ? title
        : title.split(this.whiteListFlag)[0];
    },
    isWhiteList(whiteList) {
      return whiteList.indexOf(this.whiteListFlag) === -1 ? false : true;
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  p {
    margin-bottom: 0;
    li {
      margin-top: 0;
    }
  }
}
.inner-wrap {
  padding: 10px;
  img.icon {
    width: 100%;
  }
}
.tab {
  display: flex;
  padding: 0 10px;
  .menu {
    flex: 1;
    height: 40px;
    border: 1px solid #ccc;
    border-width: 1px 1px 1px 0;
    font-size: 14px;
    p {
      padding: 9px 0;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #222222;
    }
    &:first-child {
      border: 1px solid #ccc;
    }
    &.active {
      background-color: #000832;
      border: 1px solid #000832;
      p {
        font-size: 15px;
        line-height: normal;
        letter-spacing: -0.47px;
        color: #fff;
      }
    }
  }
}
.IEO-list-wrap {
  padding: 10px;
  .IEO-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* padding: 22px 15px; */
    margin-bottom: 10px;
    border: 1px solid #dcdfe3;
    border-radius: 16px;
    box-sizing: border-box;
    background: #fff;
    .IEO-upper {
      flex: 1 1 auto;
      display: flex;
      font-family: "spoqa Han Sans", "Noto Sans KR", sans-serif;
      .IEO-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1 1 auto;
        margin-bottom: 0;
        .header {
          word-break: break-all;
          .image-wrap {
            border-bottom: 1px solid #dcdfe3;
            &.eventOver {
              position: relative;
              .image-box {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 16px 16px 0 0;
                background: rgba(0, 0, 0, 0.7);
                .text-wrap {
                  position: absolute;
                  top: 34%;
                  left: 50%;
                  transform: translate(-50%);
                  width: 100%;
                  p {
                    color: #fff;
                    text-align: center;
                    &.top {
                      width: 150px;
                      height: 38px;
                      margin: 0 auto;
                      border: 1px solid #fff;
                      line-height: 38px;
                      font-size: 17px;
                      font-weight: bold;
                      letter-spacing: -0.5px;
                    }
                    &.sub {
                      margin-top: 10px;
                      font-size: 14px;
                      font-weight: normal;
                      line-height: normal;
                      letter-spacing: normal;
                    }
                  }
                }
              }
            }
            &.soldout {
              position: relative;
              .image-box {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.7);
                .text-wrap {
                  position: absolute;
                  top: 34%;
                  left: 50%;
                  transform: translate(-50%);
                  width: 100%;
                  p {
                    color: #eb2020;
                    text-align: center;
                    &.top {
                      width: 150px;
                      height: 38px;
                      margin: 0 auto;
                      border: 1px solid #eb2020;
                      line-height: 38px;
                      font-size: 17px;
                      font-weight: bold;
                      letter-spacing: -0.5px;
                    }
                    &.sub {
                      margin-top: 10px;
                      font-size: 14px;
                      font-weight: normal;
                      line-height: normal;
                      letter-spacing: normal;
                      color: #fff;
                    }
                  }
                }
              }
            }
          }
          .contents-wrap {
            padding: 16px;
          }
          .title-wrap {
            position: relative;
            .badge-wrap {
              display: flex;
              width: fit-content;
              padding: 5px;
              margin-bottom: 4px;
              align-items: center;
              justify-content: center;
              color: #eb2020;
              border-radius: 4px;
              background-color: rgba(235, 50, 70, 0.1);
              .status-badge {
                width: fit-content;
                border-radius: 4px;
                font-size: 12px;
              }
              &.end {
                color: #707a8a;
                background-color: #e5e6ea;
              }
              &.whiteList {
                color: #00b473;
                background-color: rgba(0, 180, 115, 0.1);
              }
            }
            .Dday {
              position: absolute;
              top: 0;
              right: 0;
              width: 55px;
              height: 35px;
              border: 1px solid #fe0000;
              border-radius: 6px;
              font-size: 14px;
              font-weight: bold;
              font-stretch: normal;
              line-height: 35px;
              letter-spacing: normal;
              text-align: center;
              color: #fe0000;
            }
          }
          .contents-wrap {
            p.sub {
              margin-top: 4px;
              font-size: 16px;
            }
          }
          .date-wrap {
            margin-top: 10px;
          }
          .title {
            font-size: 18px;
            font-weight: bold;
            line-height: 1.33;
            letter-spacing: normal;
            color: #333d48;
          }
          .sub {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.29;
            letter-spacing: normal;
          }
          img {
            width: 100%;
            flex: 0 0 auto;
            border-radius: 16px 16px 0 0;
            vertical-align: middle;
          }
        }
        .period {
          margin-top: 12px;
          font-size: 14px;
          font-weight: normal;
          line-height: 1.29;
          letter-spacing: 0.5px;
          color: #666666;
        }
        .minPurchase {
          display: flex;
          justify-content: space-between;
          margin-top: 12px;
          span {
            font-size: 14px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: normal;
            color: #122f65;
          }
        }
      }
      .IEO-btn {
        flex: 0 0 85px;
        .offer-status {
          width: 100%;
          &.available {
            height: 100%;
          }
        }
      }
    }
    .progress {
      flex: 1 1 auto;
      text-align: center;
      margin-top: 17px;
      .progress-title {
        font-size: 12px;
      }
    }
  }
}
</style>
